var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256.969,
    cy: 256,
    r: 157.538,
    fill: "#0E7772"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275.692 123.642L182.073 361.887H244.701L338.966 123.642H275.692Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M368.02 361.887H473.907L512 319.274H378.996C360.918 319.274 348.005 299.259 348.005 277.952C348.005 256.646 362.855 235.985 392.555 235.985H446.144L483.591 194.663H385.453C358.335 194.663 300.227 213.387 300.227 277.952C300.227 342.517 353.17 361.887 368.02 361.887Z",
    fill: "#0A0A0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6191 123.642L0 361.887H62.628L156.893 123.642H93.6191Z",
    fill: "#0A0A0A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.301 123.642L91.6821 361.887L165.932 332.832L248.575 123.642H185.301Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2dfd6026f1e4f7ba79ffe8eb853c7a63.svg";
export { ForwardRef as ReactComponent };